import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';

const supportEmail = 'info.premcosmetics@gmail.com';

const retainedItems = [
  'Order invoices, tax records, payment records, refund records, and fraud-prevention records may be retained where required by law or business compliance.',
  'Customer support conversations may be retained for service quality, dispute handling, and legal compliance.',
  'Backups and logs may keep limited deleted data for a short period before automatic removal from backup systems.',
];

const DeleteAccount = () => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const copySupportEmail = async () => {
    await navigator.clipboard.writeText(supportEmail);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />

      <main className="flex-grow pt-24">
        <section className="mx-auto w-full max-w-5xl px-6 pb-14 pt-8 md:px-10">
          <div className="mb-8 border-b border-[#DFDFDF] pb-6">
            <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-[#D2464B]">
              ShreePremCosmetics
            </p>
            <h1 className="mb-4 text-3xl font-bold text-[#030712] md:text-4xl">
              Account deletion request
            </h1>
            <p className="max-w-3xl text-base leading-7 text-[#575757]">
              You can request deletion of your ShreePremCosmetics app account and associated personal data from inside the app or by contacting support.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            <section className="rounded border border-[#DFDFDF] bg-white p-6">
              <h2 className="mb-4 text-xl font-semibold text-[#030712]">
                Delete from the app
              </h2>
              <ol className="space-y-3 text-[#575757]">
                <li>1. Open the ShreePremCosmetics app.</li>
                <li>2. Go to Account.</li>
                <li>3. Open Settings.</li>
                <li>4. Tap Delete Account and confirm the request.</li>
              </ol>
            </section>

            <section className="rounded border border-[#DFDFDF] bg-white p-6">
              <h2 className="mb-4 text-xl font-semibold text-[#030712]">
                Request by email
              </h2>
              <p className="mb-4 leading-7 text-[#575757]">
                Send your deletion request from your registered phone number or email address and include your name and mobile number used in the app.
              </p>
              <p className="mb-4 text-base font-semibold text-[#030712]">
                {supportEmail}
              </p>
              <div className="flex flex-wrap gap-3">
                <button
                  className="inline-flex items-center justify-center rounded bg-[#D2464B] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#B7383E]"
                  type="button"
                  onClick={copySupportEmail}
                >
                  {copied ? 'Email copied' : 'Copy email'}
                </button>
                <a
                  className="inline-flex items-center justify-center rounded border border-[#D2464B] px-5 py-3 text-sm font-semibold text-[#D2464B] transition hover:bg-[#FFF1F2]"
                  href={`mailto:${supportEmail}?subject=ShreePremCosmetics%20account%20deletion%20request`}
                >
                  Open email app
                </a>
              </div>
              <a
                className="mt-4 block text-sm font-semibold text-[#D2464B] underline"
                href="https://mail.google.com/mail/?view=cm&fs=1&to=info.premcosmetics@gmail.com&su=ShreePremCosmetics%20account%20deletion%20request"
                target="_blank"
                rel="noopener noreferrer"
              >
                Compose in Gmail
              </a>
            </section>
          </div>

          <section className="mt-8 rounded border border-[#DFDFDF] bg-white p-6">
            <h2 className="mb-4 text-xl font-semibold text-[#030712]">
              Data deleted
            </h2>
            <p className="leading-7 text-[#575757]">
              When your request is processed, your app account, profile details, saved addresses, authentication details, and other personal data associated with the account will be deleted or de-identified, unless retention is required for legal, security, tax, payment, or dispute-resolution purposes.
            </p>
          </section>

          <section className="mt-8 rounded border border-[#DFDFDF] bg-white p-6">
            <h2 className="mb-4 text-xl font-semibold text-[#030712]">
              Data that may be retained
            </h2>
            <ul className="space-y-3 text-[#575757]">
              {retainedItems.map((item) => (
                <li key={item} className="leading-7">
                  {item}
                </li>
              ))}
            </ul>
            <p className="mt-4 leading-7 text-[#575757]">
              Retained records may be kept for up to 8 years where required for accounting, tax, payment, fraud-prevention, legal, or regulatory obligations.
            </p>
          </section>

          <section className="mt-8 rounded border border-[#DFDFDF] bg-white p-6">
            <h2 className="mb-4 text-xl font-semibold text-[#030712]">
              Processing time
            </h2>
            <p className="leading-7 text-[#575757]">
              Account deletion requests are usually processed within 30 days after verification. Some retained records may remain for the retention periods described above.
            </p>
          </section>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DeleteAccount;
